/* ================================
   CART QUANTITY
================================ */

function cartVariant(){
  document.querySelectorAll('.ci_plus a').forEach(function(plus){
    plus.addEventListener('click', function(e){
      e.preventDefault();
      e.stopImmediatePropagation();
      var input = plus.closest('.ci_qtybox').querySelector('.cart_qty');
      input.value = parseInt(input.value) + 1;
      var new_line = this.getAttribute('data-line-item');
      var new_qty = input.value;
      if(new_line && new_qty){
        updateItem(new_line, new_qty);
      }
    });
  });

  document.querySelectorAll('.ci_minus a').forEach(function(minus){
    minus.addEventListener('click', function(e){
      e.preventDefault();
      e.stopImmediatePropagation();
      var input = minus.closest('.ci_qtybox').querySelector('.cart_qty');
      var currentQty = parseInt(input.value);
      if(currentQty > 0){
        input.value = currentQty - 1;
        var new_line = this.getAttribute('data-line-item');
        var new_qty = input.value;
        if(new_line && new_qty){
          updateItem(new_line, new_qty);
        }
      }
    });
  });
}


/* ================================
   COMPLEMENTARY PRODUCTS
================================ */

function initComplementarySlider(container){
  if(!container) return;
  const productId = container.dataset.productId;
  const limit = container.dataset.limit || 6;
  if(!productId) return;

  const slider = container.querySelector(".complementary-slider");
  if(!slider) return;
  fetch(`/recommendations/products.json?product_id=${productId}&limit=${limit}&intent=complementary`)
  .then(response => response.json())
  .then(data => {

    if(!data.products || !data.products.length){
      container.style.display = "none";
      return;
    }

    let html = "";
    data.products.forEach(product => {
      const variant = product.variants[0];
      const image = product.featured_image ? product.featured_image : "";
      let skuHtml = '';
      if (variant.sku && variant.sku.trim() !== '') {
        skuHtml = `
          <div class="comp-code">
            <strong>PRODUCT CODE</strong> ${variant.sku}
          </div>
        `;
      }
      html += `
      <div class="complementary-item">
        <div class="comp-image">
          ${image ? `<img src="${image}" alt="${product.title}" loading="lazy">` : ""}
        </div>
        <div class="comp-info">
          ${skuHtml}
          <div class="comp-title">
            ${product.title}
          </div>
          <div class="comp-price">
            ${Shopify.formatMoney(variant.price)}
          </div>
        </div>
        <div class="comp-add">
          <button class="comp-add-btn" data-variant="${variant.id}">
            Add
          </button>
        </div>
      </div>
      `;
    });

    slider.innerHTML = html;
    /* destroy flickity if already loaded */
    if(slider.classList.contains("flickity-enabled")){
      const flkty = Flickity.data(slider);
      if(flkty) flkty.destroy();
    }

    /* init flickity */
    new Flickity(slider,{
      cellAlign: "left",
      contain: true,
      pageDots: false,
      prevNextButtons: true,
      wrapAround: false,
      draggable: true,
      imagesLoaded: true
    });

  })
  .catch(error => {
    console.error("Complementary products error:", error);
  });
}


function loadCartComplementary(){
  const containers = document.querySelectorAll(".cart-complementary-products");
  if(!containers.length) return;
  containers.forEach(function(container){
    initComplementarySlider(container);
  });
}


/* ================================
   ADD COMPLEMENTARY PRODUCT
================================ */

document.addEventListener("click", function(e){
  const btn = e.target.closest(".comp-add-btn");
  if(!btn) return;
  e.preventDefault();
  const variantId = btn.dataset.variant;
  if(!variantId) return;
  btn.classList.add("loading");
  fetch('/cart/add.js', {
    method: 'POST',
    headers: {
      'Content-Type': 'application/json'
    },
    body: JSON.stringify({
      items: [{
        id: variantId,
        quantity: 1
      }]
    })
  })

  .then(res => res.json())
  .then(() => {
    load_cart();
  })

  .catch(error => {
    console.error("Add complementary error:", error);
  });
});


/* ================================
   LOAD CART DRAWER
================================ */

function load_cart(){
  fetch(window.Shopify.routes.root + '?section_id=cart-drawer')
  .then((response) => response.text())
  .then((responseText) => {
    const cartid = 'cart-drawer';
    const html = new DOMParser().parseFromString(responseText, 'text/html');
    const destination = document.querySelector('.cart-drawer-wrapper');
    const source = html.getElementById(cartid);
    if(source && destination){
      destination.innerHTML = source.innerHTML;
    }

    /* REMOVE ITEM */
    document.querySelectorAll('.item-remove').forEach(function(cartRemove){
      var data_line = cartRemove.dataset.line;
      cartRemove.addEventListener('click', (evt) => updateItem(data_line,0));
    });


    /* OPEN CART DRAWER */
    document.querySelectorAll('.site-header-cart--button').forEach(function(cartButton){
      cartButton.addEventListener('click', function(e){
        if(__st.p != 'cart'){
          e.preventDefault();
          e.stopImmediatePropagation();
          document.querySelector('body').classList.toggle('open-drawer');
          document.querySelector('body').classList.remove('open-menu','open-search','open-sort','open-filter');
        }
      });
    });

    function overlay(){
      document.querySelectorAll('.overlay-box,.cart-drawer-close').forEach(function(cartButton){
        cartButton.addEventListener('click', function(e){
          e.preventDefault();
          e.stopImmediatePropagation();
          const createdUlElements = document.querySelectorAll('.wpp-meta-ul');
          createdUlElements.forEach(ul => ul.remove());
          document.querySelector('body').classList.remove(
            'open-quick-buy',
            'open-drawer',
            'open-menu',
            'open-search',
            'open-sort',
            'open-filter',
            'open-mobile-search',
            'filter-sticky',
            'active-wishli-pro',
            'open-size-chart'
          );
        });
      });
    }

    headerTotal();
    overlay();
    cartVariant();
    /* LOAD COMPLEMENTARY PRODUCTS */
    loadCartComplementary();
    /* UPDATE HEADER CART COUNT */
    fetch('/cart.js')
    .then((resp) => resp.json())
    .then(function(data){
      var cart_count = data.item_count;
      var cartCountEl = document.querySelector('.site-header-cart--count');
      if(cart_count > 0){
        cartCountEl.classList.add('visible');
        // document.querySelector('.site-icontext-carttotal').innerText = Shopify.formatMoney(data.total_price);
        // document.querySelector('.site-icontext-carttotal').innerHTML = `${Shopify.formatMoney(data.total_price)}`;
        function formatMoney(cents) {
          return `$${(cents / 100).toFixed(2)}`;
        }
        document.querySelector('.site-icontext-carttotal').textContent = formatMoney(data.total_price);
      }else{
        cartCountEl.classList.remove('visible');
      }
      cartCountEl.setAttribute('data-header-cart-count', cart_count);
    });
  });
}

load_cart();

/* ================================
   UPDATE CART ITEM
================================ */

function updateItem(data_line, data_qty){
  const data = {
    id: data_line,
    quantity: data_qty
  };
  fetch('/cart/change.js',{
    method: 'POST',
    headers: {
      'Content-Type': 'application/json',
    },
    body: JSON.stringify(data)
  })
  .then((response) => response.json())
  .then((data) => {
    if(document.location.href.indexOf('/cart') > -1){
      window.location.href = "/cart";
    }else{
      load_cart();
      setTimeout(function(){
        document.querySelector('body').classList.add('open-drawer');
      },500);
    }
  })
  .catch((error) => {
    console.error('Error:', error);
  });
}

/* ================================
   HEADER TOTAL
================================ */
function headerTotal(){
  var url = window.location.href;
  fetch(url)
  .then(response => response.text())
  .then(html => {
    var parser = new DOMParser();
    var doc = parser.parseFromString(html, 'text/html');
    if(doc.querySelector('.header-cart-total') != null){
      var mainSectionContent = doc.querySelector('.header-cart-total').innerHTML;
      document.querySelector('.header-cart-total').innerHTML = mainSectionContent;
    }
  })
  .catch(error => {
    console.error('Error fetching cart total:', error);
  });
}

/* ================================
   ORDER NOTE TOGGLE
================================ */
document.addEventListener("click", function (e){
  const btn = e.target.closest(".cart-ordernote-btn");
  if(!btn) return;
  const note = document.querySelector(".cart-ordernote");
  if(!note) return;
  note.classList.toggle("hide-drawer-note");
});